module.exports = __webpack_public_path__ + "static/media/codewindow.42f55347.gif";